import { render, staticRenderFns } from "./CourseEffectCategories.vue?vue&type=template&id=14232020&"
import script from "./CourseEffectCategories.vue?vue&type=script&lang=js&"
export * from "./CourseEffectCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports